import type { AtmospherePreset } from '../presets.config';
import { biomeCloser, multiPlaneParallax } from '../presetBuilders';
import { FOREST_JOURNEY_BACKDROPS } from '../../../game/effects/atmosphere/silhouettes/forestJourneyBackdrops';
import { FOREST_DEPTH_BACKDROPS, FOREST_DEPTH_HEIGHTS } from '../../../game/effects/atmosphere/silhouettes/forestDepthBackdrops';

type ForestStage = keyof typeof FOREST_JOURNEY_BACKDROPS;

function woodland(id: ForestStage, sky: number, mid: number, light: number): AtmospherePreset {
  const art = FOREST_JOURNEY_BACKDROPS[id];
  const tall = id === 'deep_woods' || id === 'old_grove';
  const far = tall ? { svg: FOREST_DEPTH_BACKDROPS[id], height: FOREST_DEPTH_HEIGHTS[id],
    alpha: id === 'deep_woods' ? .60 : .58 } : { svg: art.far, height: 620, alpha: .72 };
  return { id, layers: [
    { kind: 'skyGradient', from: 0x10241f, to: sky },
    ...multiPlaneParallax([
      { shape: 'ridge', color: 0x49664d, speed: .025, height: far.height, alpha: far.alpha, svg: far.svg },
      { shape: 'ridge', color: mid, speed: .07, height: 470, alpha: .86, svg: art.mid },
      { shape: 'ridge', color: 0x172e22, speed: .14, height: 165, alpha: .8, svg: art.near },
    ]),
    { kind: 'fireflies', count: 12, colors: [0xc8c58f, 0xabcaa0], sizeMin: 9, sizeMax: 18,
      driftPx: 22, periodMinMs: 9000, periodMaxMs: 16000, alphaMin: .25, alphaMax: .65 },
    { kind: 'godRays', count: 3, color: light, widthMin: 55, widthMax: 110,
      height: 590, tiltDeg: 12, periodMinMs: 14000, periodMaxMs: 22000, alphaMin: .08, alphaMax: .24 },
    { kind: 'fog', color: 0xa2b3a0, bands: 3, alphaMin: .025, alphaMax: .065,
      driftPx: 38, periodMinMs: 19000, periodMaxMs: 27000 },
    ...biomeCloser({ grade: { top: light, bottom: 0x243d2c, strength: .06 } }),
  ] };
}

export const FOREST_JOURNEY_PRESETS: Record<ForestStage, AtmospherePreset> = {
  forest_road: woodland('forest_road', 0x59755c, 0x34543b, 0xd7c893),
  deep_woods: woodland('deep_woods', 0x3d5843, 0x244532, 0xbdc99a),
  abandoned_camp: woodland('abandoned_camp', 0x687356, 0x3d5941, 0xe0c393),
  old_grove: woodland('old_grove', 0x435b46, 0x2d4835, 0xc7cfa6),
};
